//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React, { createRef } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import validator from 'validator';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Form, Header, Checkbox, MobileMenu, Modal } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { ScreenSet, showScreenSet } from '@helpers/gigya';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import '@helpers/form';

//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import { DoNotSellMyPersonalDataURL } from '@helpers/constants/colgate';
import { withTranslation } from 'react-i18next';
import { removeEmptyAddresses } from '@helpers/gigya';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.scrollRef = createRef();
    this.state = {
      toggle: false,
      showSiteNotice: true,
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleCloseSiteNotice = this.handleCloseSiteNotice.bind(this);
  }

  handleCloseSiteNotice() {
    this.setState({ showSiteNotice: false });
  }

  componentDidMount() {
    const {
      storeConfig: { language },
    } = this.context;

    showScreenSet(
      language,
      {
        ...ScreenSet.SignUp,
        events: {
          onAfterScreenLoad: (e) => {
            document
              .getElementById('signup-container')
              .querySelectorAll('.gigya-input-text,.gigya-input-password')
              .forEach((nodeInput) => {
                nodeInput.addEventListener('keyup', (event) => {
                  window.interactiveLabel(event);
                });
              });
            removeEmptyAddresses(e);
            this.handleGigyaCheckbox(e, language);
            this.handleFormAttributes();
            this.handleAfterSubmit();
          },
        },
      },
      'signup-container'
    );
  }

  handleGigyaCheckbox = (e, language) => {
    //this logic was removed from the onFieldchange gigya sdk event and added in front end
    //the Ids are KR specific and wont change
    if (language === 'ko') {
      document.getElementById('gigya-checkbox-73237886114371310')
        ? document
            .getElementById('gigya-checkbox-73237886114371310')
            .addEventListener('change', (event) => {
              if (event.target.checked) {
                document.getElementById(
                  'gigya-checkbox-46638028426016880'
                ).checked = true;
                document.getElementById(
                  'gigya-checkbox-81716477796530300'
                ).checked = true;
              } else {
                document.getElementById(
                  'gigya-checkbox-46638028426016880'
                ).checked = false;
                document.getElementById(
                  'gigya-checkbox-81716477796530300'
                ).checked = false;
              }
            })
        : null;

      document.getElementById('gigya-checkbox-46638028426016880')
        ? document
            .getElementById('gigya-checkbox-46638028426016880')
            .addEventListener('change', (event) => {
              if (
                event.target.checked &&
                document.getElementById('gigya-checkbox-81716477796530300')
                  .checked
              ) {
                document.getElementById(
                  'gigya-checkbox-73237886114371310'
                ).checked = true;
              } else {
                document.getElementById(
                  'gigya-checkbox-73237886114371310'
                ).checked = false;
              }
            })
        : null;

      document.getElementById('gigya-checkbox-81716477796530300')
        ? document
            .getElementById('gigya-checkbox-81716477796530300')
            .addEventListener('change', (event) => {
              if (
                event.target.checked &&
                document.getElementById('gigya-checkbox-46638028426016880')
                  .checked
              ) {
                document.getElementById(
                  'gigya-checkbox-73237886114371310'
                ).checked = true;
              } else {
                document.getElementById(
                  'gigya-checkbox-73237886114371310'
                ).checked = false;
              }
            })
        : null;
    }
  };

  handleAfterSubmit = () => {
    this.scrollRef.current.scrollIntoView(false);
  };

  handleFormAttributes = () => {
    const formElements = Array.from(document.querySelectorAll('form, input'));
    formElements.forEach((element) =>
      element.setAttribute('autocomplete', 'off')
    );
  };

  additionalComponent() {
    const { t } = this.props;
    return <div className={styles.AdditionalComponent}></div>;
  }

  handleToggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }

  render() {
    const { history, t } = this.props;
    const { toggle, showSiteNotice } = this.state;
    const { handleToggle, handleCloseSiteNotice } = this;
    const {
      storeConfig: { language },
    } = this.context;
    const componentClasses = classNames(styles.SignUp);
    const showJpSiteNotice = language === 'ja' && showSiteNotice;

    const mobileStyle = toggle
      ? {
          backgroundColor: 'white',
          paddingTop: 0,
        }
      : {};

    return (
      <div className={componentClasses} style={mobileStyle}>
        <Helmet>
          <title>{t('login_CreateAnAccount')}</title>
        </Helmet>

        <Header toggle={toggle} onToggle={handleToggle} />
        {toggle ? (
          <div className={styles.ContentMobile}>
            <MobileMenu />
          </div>
        ) : (
          <>
            <CreateAccountHeading scrollRef={this.scrollRef} />
            <div className={styles.FormBlock}>
              <Form
                className={styles.Form}
                title={''}
                additionalComponent={this.additionalComponent()}
                id="signup-container"
              />
            </div>
          </>
        )}
        {showJpSiteNotice && (
          <Modal.Base
            className={styles.SiteNoticeModal}
            onClose={handleCloseSiteNotice}
          >
            <div className={styles.SiteNoticeContainer}>
              <p className={styles.SiteNoticeText}>
                {t('signup_SiteNoticeTitle')}
              </p>
              <p className={styles.SiteNoticeText}>
                {t('signup_SiteNoticeGsfPrefix')}
                <a
                  className={styles.SiteNoticeLink}
                  href={t('url_signup_GsfRegistration')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('signup_SiteNoticeGsfLink')}
                </a>
                {t('signup_SiteNoticeGsfSuffix')}
              </p>
            </div>
          </Modal.Base>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(SignUp);
SignUp.contextType = StoreConfigContext;

function CreateAccountHeadingComponent({ t, className, scrollRef }) {
  return (
    <div className={className || styles.HeadingSection} ref={scrollRef}>
      <div className={styles.GoBack}>
        <a href="/">&lt;</a>
        <a href="/">{t('header_title')}</a>
      </div>
      <h2 className={styles.SignUpTitle}>{t('login_CreateAccount')}</h2>
    </div>
  );
}

export const CreateAccountHeading = withTranslation()(
  CreateAccountHeadingComponent
);
